import { render, staticRenderFns } from "./check-mail.vue?vue&type=template&id=4ccf62f4"
import script from "./check-mail.js?vue&type=script&lang=js&external"
export * from "./check-mail.js?vue&type=script&lang=js&external"
import style0 from "./check-mail.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports